module.exports = __webpack_public_path__ + "static/img/ls4.ad2ea1f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-edge/ls4.png
// module id = r2jE
// module chunks = 12